<header>
  <nav class="navbar p-0 bg-white">
    <div class="container-fluid">
      <div class="col-sm-12 d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <a
      class="navbar-brand mb-0"
      [class.disabled]="isHiddenHeader"
      [attr.href]="isHiddenHeader ? null : '/#/home'"
      [attr.aria-disabled]="isHiddenHeader"
      [attr.tabindex]="isHiddenHeader ? -1 : 0"
      >
            <img
              src="../../../../assets/logos/Icone-FGC.ico"
              height="90" alt="Logo da FGC"
              loading="lazy"
            />
        </a>
        <span class="page-text">Portal Investidor</span>
        </div>
        <ul  class="navbar-nav flex-row d-flex align-items-center">
          <li *ngIf="!customHeader && !isHiddenHeader" class="nav-item">
            <a href="https://www.fgc.org.br" target="_blank" class="custom-fgc-label">Tire suas dúvidas</a>
          </li>
          <li *ngIf="!customHeader && !isHiddenHeader" class="nav-item">
            <button data-testid="botao-solicitar-acompanhar" class="btn" (click)="autenticacao()">
              Solicitar minha garantia
            </button>
          </li>
          <li *ngIf="!customHeader && isHiddenHeader" class="nav-item">
              <a data-testid="botao-voltar-inicio" class="custom-fgc-label" (click)="voltarInicio()">
                <i class="fas fa-sign-out-alt icon"></i> Voltar
              </a>
            </li>
          <li *ngIf="customHeader && !isHiddenHeader" class="nav-item">
              <a data-testid="botao-voltar-inicio" href="#" class="custom-fgc-label">
                Início
              </a>
            </li>
        </ul>
      </div>
    </div>
  </nav>
</header>
<ng-content ></ng-content>
